export default __webpack_public_path__ + "static/media/miscellaneous15.ba27e4e1.png";